export const TOOLTIP_DARK_THEME_CLASSES = "d-tooltip";
export const TOOLTIP_DELAY_SHOW = 300;
